import { catchError, useTranslation } from "@opendash/core";
import { Col, Image, Row, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Media, Schedule_Template } from "../../../js/parsegenerated";

export const StepMedia = observer(
  (props: { scheduletemplate: Schedule_Template }) => {
    const t = useTranslation();
    const [media, setMedia] = useState<Media[]>([]);

    useEffect(() => {
      const fetchmedia = async () => {
        const [stepserror, steps] = await catchError(
          props.scheduletemplate.get("steps").query().find()
        );

        for await (const step of steps) {
          const [mediaerror, mediafiles] = await catchError(
            step.get("media").query().find()
          );
          setMedia(mediafiles);
        }
      };

      fetchmedia();
    }, [props.scheduletemplate]);

    return (
      <>
        {media.length > 0 ? (
          <Typography.Title level={4}>
            {t("maintenance:schedule.step.media.headline")}
          </Typography.Title>
        ) : null}
        <Row gutter={[16, 16]} justify="start" align="top">
          {media.map((m, index) => (
            <Col key={m.get("id")}>
              <Image src={m.get("media").url()} height={100} />
            </Col>
          ))}
        </Row>
      </>
    );
  }
);
